if (process.env.NODE_ENV === 'production') {
  module.exports = require('./config.prod');
} else if (process.env.NODE_ENV === 'prototype'){
  module.exports = require('./config.py');
} else {
  module.exports = require('./config.dev');
}
